import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { LogoutType } from '@enums/logout-types.enum';
import { TokenService } from '@services/outros//token.service';
import { UserControllerService } from '@services/outros/user-controller.service';
import { UserPermissionsService } from '@core/services/outros/user-permissions.service';

@Injectable()
export class RulesGuard implements CanActivate {

  constructor(
    private tokenService: TokenService,
    private userControllerService: UserControllerService,
    private router: Router,
    private userPermissions: UserPermissionsService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state.url !== '/') {
      if (this.isRestrictedFinanceiroUrl(state.url) && !this.hasAccessToFinanceiro(state.url)) {
        this.router.navigate(['/home']);
        return false;
      }

      if (this.userControllerService.recoverFromStorage()) {
        this.userControllerService.setFromStorage();
      } else if (this.tokenService.isTokenExpired()) {
        this.userPermissions.clear();
        this.userControllerService.logout(LogoutType.Expires);
        this.router.navigate(['/login']);
        return false;
      } else {
        this.router.navigate(['/login']);
        return false;
      }
    }
    return true;
  }


  private isRestrictedFinanceiroUrl(url: string): boolean {
    return url.includes('financeiro');
  }

  private hasAccessToFinanceiro(url: string): boolean {
    const user = this.userControllerService.getUserLogged();
    const type = user?.type;

    const cleanUrl = url.split('?')[0];

    if (cleanUrl.endsWith('/financeiro/carrinho-de-compras')) {
      return true;
    }

    if (cleanUrl.includes('/financeiro/contratos')) {
      return false;
    }

    return type === 'ADMINISTRADOR' || type === 'SUPERVISOR' || type === 'FINANCEIRO';
  }
}
